export default __webpack_public_path__ + "static/media/login-bg.92130f92.jpg";